import useDialog from '@hooks/useDialog';
import { ContentCopyRounded, DeleteOutlineRounded } from '@mui/icons-material';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate, useParams } from '@tanstack/react-router';
import { closeOptions } from '@utils/utils';
import { createElement } from 'react';
import { Trans, useTranslation } from 'react-i18next';

const useEmailDraftOptions = () => {
    const { t } = useTranslation();
    const { draftId } = useParams({});
    const navigate = useNavigate();

    const dialog = useDialog();
    const queryClient = useQueryClient();

    const refetch = () =>
        queryClient.invalidateQueries({ queryKey: ['emailsDrafts'] });

    const deleteMutation = useMutation({
        mutationKey: ['deleteEmailDraft'],
        onSuccess: () => {
            dialog.close();
            closeOptions();
            refetch();
            if (draftId) {
                navigate({ to: '/emails/drafts' });
            }
        },
    });

    const duplicateMutation = useMutation({
        mutationKey: ['duplicateEmailDraft'],
        onSuccess: res => {
            navigate({ to: `/emails/drafts/${res.id}` });
        },
    });

    const getOptions = item => ({
        deleteEmail: {
            label: t('Delete'),
            Icon: DeleteOutlineRounded,
            sx: { color: 'error.main' },
            onClick: () =>
                dialog.open({
                    confirmLabel: t('Delete'),
                    title: t('Delete Draft') + '?',
                    message: createElement(Trans, {
                        t,
                        values: { subject: item.subject },
                        children: 'prompts:content.deleteDraft',
                    }),
                    onConfirm: () => item.id,
                    confirmMutation: deleteMutation,
                    confirmButtonProps: {
                        color: 'error',
                    },
                }),
        },
        duplicate: {
            label: t('Make a Copy'),
            onClick: () => duplicateMutation.mutate(item.id),
            Icon: ContentCopyRounded,
        },
    });

    return getOptions;
};

export default useEmailDraftOptions;
